import React from 'react';
import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {useDispatch, useSelector} from 'react-redux';
import * as snackbarsActions from '../../../../../actions/snackbars';
import RowView from './RowView';
import userService from '../../../../../services/user/UserService';
import {captureError} from '../../../../../utils/log';

function RowContainer(props) {
  const organisation = useSelector(state => state.organisation);
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  function handleUnlink() {
    setLoading(true);
    userService.unlinkUserFromOrganisation(props.user.id, organisation.organisationId)
      .then(() => {
        props.onUnlinkSuccess();
        setLoading(false);
      })
      .catch(error => {
        dispatch(snackbarsActions.addError(<Translate value="error.generic"/>));
        captureError('Error while unlinking user from organisation', error);
      });
  }

  return (
    <RowView
      loading={loading}
      user={props.user}
      organisationId={organisation.organisationId}
      onUnlink={handleUnlink}
    />
  );
}

RowContainer.propTypes = {
  user: PropTypes.object.isRequired,
  onUnlinkSuccess: PropTypes.func.isRequired
};

export default RowContainer;
